
import { Component, Vue } from "vue-property-decorator";
import {
  dispatchDeleteProject,
  dispatchGetProjects,
} from "@/store/main/actions";
import {
  readHasAdminAccess,
  readProjects,
  readUserProfile,
} from "@/store/main/getters";
import { Project } from "@/interfaces";

@Component
export default class Projects extends Vue {
  public headers = [
    {
      text: "نام ",
      sortable: true,
      value: "name",
      align: "right",
    },
    {
      text: "تعداد درخواست ها",
      sortable: true,
      value: "requests_count",
      align: "right",
    },
    {
      text: "تعداد درخواست های فعال",
      sortable: true,
      value: "active_requests_count",
      align: "right",
    },
    {
      text: "وضعیت",
      sortable: true,
      value: "active",
      align: "right",
    },
    {
      text: "حذف",
      sortable: false,
      value: "delete",
      align: "right",
    },
    {
      text: "نمایش",
      value: "data-table-expand",
      align: "right",
    },
  ];

  public fetched = false;
  public dialog = false;
  public selectedProject: Project | null = null;
  public expanded = [];

  get isAdmin() {
    return readHasAdminAccess(this.$store);
  }
  get projects() {
    return readProjects(this.$store);
  }

  public showProject(value) {
    this.$router.push({ name: "main-project-view", params: { id: value.id } });
  }

  get userProfile() {
    return readUserProfile(this.$store);
  }

  public hashText(currency_id) {
    return "+++";
  }

  public async mounted() {
    if (this.isAdmin) {
      this.headers.splice(0, 0, {
        text: "ID",
        sortable: true,
        value: "id",
        align: "right",
      });
    }

    const own = !this.isAdmin; // if user is admin, set own to false
    await Promise.allSettled([dispatchGetProjects(this.$store, true)]);

    this.fetched = true;
  }

  public showRemoveModal(project) {
    this.selectedProject = project;
    this.dialog = true;
  }

  public async remove() {
    this.dialog = false;
    this.fetched = false;

    const id = this.selectedProject?.id ?? -1;
    const own = !this.isAdmin; // if user is admin, set own to false

    await Promise.allSettled([dispatchDeleteProject(this.$store, { id: id })]);

    this.fetched = true;
  }

  public getColor(index) {
    const mod = index % 10;
    switch (mod) {
      case 0:
        return "#F44336";
      case 1:
        return "#E91E63";
      case 2:
        return "#2196F3";
      case 3:
        return "#FF9800";
      case 4:
        return "#9C27B0";
      case 5:
        return "#4CAF50";
      case 6:
        return "#3F51B5";
      case 7:
        return "#607D8B";
      case 8:
        return "#009688";
      case 9:
        return "#673AB7";
    }
  }
}
